// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.well-redesign-report-page {
  padding: 20px 24px;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.report-header h2 {
  margin: 0;
  color: #0070ad;
  font-size: 24px;
  font-weight: 500;
}

.back-link {
  color: #0070ad;
  text-decoration: none;
  font-weight: 600;
}

.back-link:hover {
  text-decoration: underline;
}

.well-section h3 {
  margin: 0 0 14px;
  font-size: 28px;
  font-weight: 600;
  color: #101828;
  text-align: left;
}

.pipe-size-block {
  margin-bottom: 18px;
}

.pipe-size-block h4 {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  color: #0b2f6b;
  text-align: left;
}

.project-row {
  margin-left: 28px;
  margin-bottom: 8px;
}

.project-title {
  font-size: 18px;
  font-weight: 600;
}

.slurry-list {
  margin: 4px 0 0 20px;
  padding: 0;
}

.slurry-list li {
  list-style: none;
  font-size: 16px;
  margin-bottom: 2px;
}

.error-message {
  color: #b42318;
  font-weight: 600;
}

.spinner-container {
  padding-top: 24px;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-redesign-report/well-redesign-report.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".well-redesign-report-page {\n  padding: 20px 24px;\n}\n\n.report-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.report-header h2 {\n  margin: 0;\n  color: #0070ad;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.back-link {\n  color: #0070ad;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.back-link:hover {\n  text-decoration: underline;\n}\n\n.well-section h3 {\n  margin: 0 0 14px;\n  font-size: 28px;\n  font-weight: 600;\n  color: #101828;\n  text-align: left;\n}\n\n.pipe-size-block {\n  margin-bottom: 18px;\n}\n\n.pipe-size-block h4 {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0b2f6b;\n  text-align: left;\n}\n\n.project-row {\n  margin-left: 28px;\n  margin-bottom: 8px;\n}\n\n.project-title {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.slurry-list {\n  margin: 4px 0 0 20px;\n  padding: 0;\n}\n\n.slurry-list li {\n  list-style: none;\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.error-message {\n  color: #b42318;\n  font-weight: 600;\n}\n\n.spinner-container {\n  padding-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
